import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { IMAGES as DEFAULT_IMAGES } from "@/constants/site";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

function toAbsolute(url) {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  // /api/uploads/... must be served by backend
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  // /images/... lives in frontend public
  return url;
}

function normalize(raw) {
  const out = { ...DEFAULT_IMAGES };
  Object.keys(out).forEach((k) => {
    if (raw && raw[k]) out[k] = raw[k];
  });
  // Absolute URLs for img tags
  return Object.fromEntries(
    Object.entries(out).map(([k, v]) => [k, toAbsolute(v)])
  );
}

let cache = null;
const listeners = new Set();

async function load() {
  try {
    const { data } = await api.get("/site/images");
    cache = normalize(data);
  } catch {
    cache = normalize(null);
  }
  listeners.forEach((l) => l(cache));
  return cache;
}

export function useSiteImages() {
  const [images, setImages] = useState(cache || normalize(null));
  useEffect(() => {
    listeners.add(setImages);
    if (cache) {
      setImages(cache);
    } else {
      load();
    }
    return () => {
      listeners.delete(setImages);
    };
  }, []);
  return images;
}

// Call after admin mutations so all subscribed pages refresh.
export function refreshSiteImages() {
  return load();
}

// Helper to render the raw (admin) URL absolutely for previews.
export function absolutize(url) {
  return toAbsolute(url);
}
